"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePassword = void 0;
const isStrongPassword_1 = __importDefault(require("validator/lib/isStrongPassword"));
const validatePassword = (password) => (0, isStrongPassword_1.default)(password, {
    minLength: 8,
    minLowercase: 0,
    minUppercase: 0,
    minNumbers: 0,
    minSymbols: 0,
});
exports.validatePassword = validatePassword;
